import { Button } from 'react-bootstrap';
import { i18n } from 'app/utils/i18n';

const DateInput = ({ contextId, field, value, onChange }) => (
  <input
    type="text"
    className="roll-forward__date-input"
    placeholder="YYYY-MM-DD"
    value={value ?? ''}
    onChange={(e) => onChange(contextId, field, e.target.value || null)}
  />
);

const StepPeriods = ({ contexts, periods, onChange, onShiftAll }) => (
  <div className="roll-forward__step">
    <div className="roll-forward__periods-head">
      <h4 className="roll-forward__heading">{i18n('roll-forward.step.periods')}</h4>
      <Button variant="outline-primary" size="sm" onClick={onShiftAll}>
        {i18n('roll-forward.shift-all')}
      </Button>
    </div>
    {contexts.length === 0 ? <p className="text-gray-500">{i18n('roll-forward.no-editable-periods')}</p> : null}
    <ul className="roll-forward__context-list">
      {contexts.map((c) => {
        const p = periods[c.contextId] ?? {};
        const isInstant = !!c.periodInstant;
        return (
          <li key={c.contextId} className="roll-forward__context-row">
            <span className="roll-forward__context-label">{c.label}</span>
            <span className="roll-forward__context-inputs">
              {isInstant ? (
                <DateInput contextId={c.contextId} field="periodInstant" value={p.periodInstant} onChange={onChange} />
              ) : (
                <>
                  <DateInput contextId={c.contextId} field="periodStartDate" value={p.periodStartDate} onChange={onChange} />
                  <span className="roll-forward__date-sep">→</span>
                  <DateInput contextId={c.contextId} field="periodEndDate" value={p.periodEndDate} onChange={onChange} />
                </>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  </div>
);

export default StepPeriods;
